import React, { useEffect, useState, useRef, useMemo } from "react";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";

import { useSnackbar } from "notistack";
import AdminLoader from "../../components/common/loader/AdminLoader";
import {
  createOtherExpense,
  deleteOtherExpense,
  fetchOtherExpenses,
} from "../../store/slices/otherexpenses";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchServiceTypes } from "../../store/slices/serviceTypesSlice";
import { fetchRoles } from "../../store/slices/roleSlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import { useCurrencySymbol } from "../../utils/currencyUtils";
import CommaConvert from "../../utils/CommaConvert";
import {
  createSalesHourlyRate,
  deleteSalesHourlyRate,
  fetchSalesHourlyRates,
  updateSalesHourlyRate,
} from "../../store/slices/salesHourlyRateSlice";
import { hasFeatureAccess, getFeatureAccessLevel } from "../../utils/featureAccessUtils";

const HourlyRates = () => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const { data } = useSelector((state) => state.salesHourlyRate);
  // const { quotations } = useSelector((state) => state.hourlyRateQuotation);
  const { enqueueSnackbar } = useSnackbar();
  const [defaultOverheadPercentage, setDefaultOverheadPercentage] =
    useState("");
  const [useDefaultOverhead, setUseDefaultOverhead] = useState(false);

  const [isLoading, SetisLoading] = useState(false);
  const { employees } = useSelector((state) => state.employees);
  const email = localStorage.getItem("email");

  const { items } = useSelector((state) => state.otherExpenses);
  console.log("datadata", data);
  const [rows, setRows] = useState([
    {
      id: 0,
      designation: "",
      hourlysalaray: "",
      overheadpercentage: "",
    },
  ]);

  console.log("rowsrows", rows);

  const dropdownRefs = useRef({});
  const [searchTerm, setSearchTerm] = useState("");

  const [modifiedRows, setModifiedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isexpenseModalOpen, setisexpenseModalOpen] = useState(false);

  const [_id, setRowToDelete] = useState(null);
  const [expenseID, setexpenseID] = useState(null);

  const [openDropdownemployeeId, setopenDropdownemployeeId] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [index, setindex] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [overheadPercentage, setOverheadPercentage] = useState(null);

  console.log("overheadPercentage", overheadPercentage);

  const [otherExpenseRows, setOtherExpenseRows] = useState([
    {
      description: "",
      cost: "",
      unit: "",
    },
  ]);
  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const [expenseSortConfig, setExpenseSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [expenseSearchQuery, setExpenseSearchQuery] = useState("");

  const formatDesignationLabel = (designation = "") => {
    const raw = String(designation || "").trim();
    if (!raw) return "";
    // Display-friendly labels: keep stored values intact.
    // Examples:
    // - "Cloud project manager" -> "Cloud Manager"
    // - "Cloud operations" -> "Cloud Employee"
    const cleaned = raw
      .replace(/\bproject manager\b/gi, "Manager")
      .replace(/\boperations\b/gi, "Employee")
      .replace(/\s+/g, " ")
      .trim();
    return cleaned;
  };

  const formatOverheadDisplay = (num) => {
    if (num === undefined || num === null || num === "") return "";
    const raw = String(num).replace(/,/g, "").trim();
    const value = Number(raw);
    if (isNaN(value)) return "";
    const decimalPart = raw.includes(".") ? raw.split(".")[1] : "";
    const fractionDigits = decimalPart ? Math.min(decimalPart.length, 2) : 0;
    return value.toLocaleString("en-US", {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: 2,
    });
  };

  const currentEmployee = useMemo(
    () => employees.find((emp) => emp.EmpEmail === email),
    [employees, email]
  );

  const hasConfiguredFeatureAccess = useMemo(
    () =>
      Array.isArray(currentEmployee?.featureAccess) &&
      currentEmployee.featureAccess.length > 0,
    [currentEmployee]
  );

  // Permissions for Sales Hourly Rates (L3 – ERP)
  const canAddHourlyRates = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    if (["L0", "L1", "L4"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(
      currentEmployee,
      "SALES HOURLY RATES ADD HOURLY RATES"
    );
  }, [hasConfiguredFeatureAccess, currentEmployee]);

  const canEditHourlyRates = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    if (["L0", "L1", "L4"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(
      currentEmployee,
      "SALES HOURLY RATES EDIT HOURLY RATES"
    );
  }, [hasConfiguredFeatureAccess, currentEmployee]);

  const canDeleteHourlyRates = useMemo(() => {
    if (!hasConfiguredFeatureAccess) return true;
    if (["L0", "L1", "L4"].includes(currentEmployee?.EmpAuthLevel)) return true;
    return hasFeatureAccess(
      currentEmployee,
      "SALES HOURLY RATES DELETE HOURLY RATES"
    );
  }, [hasConfiguredFeatureAccess, currentEmployee]);

  const isViewOnly = useMemo(() => {
    if (!currentEmployee || !hasConfiguredFeatureAccess) return false;
    const addLevel = getFeatureAccessLevel(currentEmployee, "SALES HOURLY RATES ADD HOURLY RATES");
    const editLevel = getFeatureAccessLevel(currentEmployee, "SALES HOURLY RATES EDIT HOURLY RATES");
    return (
      (addLevel && String(addLevel).trim().toUpperCase() === "VIEW ONLY") ||
      (editLevel && String(editLevel).trim().toUpperCase() === "VIEW ONLY")
    );
  }, [currentEmployee, hasConfiguredFeatureAccess]);

  useEffect(() => {
    const matchedLead = employees.find(
      (employee) => employee.EmpEmail === email
    );
    const entries = items.filter((item) => item.createdBy === matchedLead?._id);

    // Add unique IDs to existing entries
    const entriesWithIds = entries.map((entry, index) => ({
      ...entry,
      id: entry._id || `existing-${index}`, // Use _id for existing, create unique for others
    }));

    setOtherExpenseRows(entriesWithIds);
  }, [items, employees, email]);

  useEffect(() => {
    dispatch(fetchSalesHourlyRates());
    dispatch(fetchRoles());
    dispatch(fetchServiceTypes());
    dispatch(fetchOtherExpenses());
    dispatch(fetchEmployees());
    dispatch(setCurrentPageTitle("Hourly Rates & Expenses"));
  }, [dispatch, enqueueSnackbar]);

  useEffect(() => {
    if (!data || data.length === 0) return;
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const filteredData = data.filter(
      (item) => item.createdBy === currentEmployee?._id
    );
    const calculatedPercents = filteredData
      .map(({ hourlysalaray, overheadpercentage }) => {
        if (!hourlysalaray) return null;
        return Number(((overheadpercentage / hourlysalaray) * 100).toFixed(2));
      })
      .filter((v) => v !== null);

    const uniquePercents = [...new Set(calculatedPercents)];

    if (uniquePercents.length === 1) {
      setDefaultOverheadPercentage(uniquePercents[0]); 
      setUseDefaultOverhead(true)
    } else {
      setOverheadPercentage(null); 
      setUseDefaultOverhead(false)
    }
  }, [data, employees]);

  // Load quotations into rows when they're available
  useEffect(() => {
    if (data && data.length > 0) {
      const userEmail = localStorage.getItem("email");
      const currentEmployee = employees.find(
        (emp) => emp.EmpEmail === userEmail
      );
      const filteredData = data.filter(
        (item) => item.createdBy === currentEmployee?._id
      );

      // ✅ Sort so that for each service type, Manager rows come before Operations rows
      const sortedData = [...filteredData].sort((a, b) => {
        const getServiceAndRole = (designation = "") => {
          let service = designation || "";
          let rolePriority = 2; // default

          if (designation.toLowerCase().includes("manager")) {
            rolePriority = 0; // Manager first
            service = designation
              .replace(/project manager/i, "")
              .replace(/manager/i, "")
              .trim();
          } else if (designation.toLowerCase().includes("operations")) {
            rolePriority = 1; // Operations after Manager
            service = designation.replace(/operations/i, "").trim();
          }

          return { service: service.toLowerCase(), rolePriority };
        };

        const aInfo = getServiceAndRole(a.designation || "");
        const bInfo = getServiceAndRole(b.designation || "");

        if (aInfo.service < bInfo.service) return -1;
        if (aInfo.service > bInfo.service) return 1;

        // Same service type → sort by role priority
        if (aInfo.rolePriority < bInfo.rolePriority) return -1;
        if (aInfo.rolePriority > bInfo.rolePriority) return 1;

        // Fallback: keep original order
        return 0;
      });

      const initialRows = sortedData.map((quote, index) => ({
        id: index,
        _id: quote._id,
        designation: quote.designation || "",
        hourlysalaray: quote.hourlysalaray
          ? quote.hourlysalaray.toString()
          : "",
        overheadpercentage: quote.overheadpercentage
          ? quote.overheadpercentage.toString()
          : "",
      }));

      // FIX: Only add empty row if the last row is not already empty
      if (initialRows.length === 0) {
        // If no data, add one empty row
        setRows([
          {
            id: 0,
            _id: null,
            designation: "",
            hourlysalaray: "",
            overheadpercentage: "",
          },
        ]);
      } else {
        // Check if last row is empty
        const lastRow = initialRows[initialRows.length - 1];
        const isLastRowEmpty =
          !lastRow.designation &&
          !lastRow.hourlysalaray &&
          !lastRow.overheadpercentage;

        // Only add empty row if last row is not empty
        if (!isLastRowEmpty) {
          initialRows.push({
            id: initialRows.length,
            _id: null,
            designation: "",
            hourlysalaray: "",
            overheadpercentage: "",
          });
        }

        setRows(initialRows);
      }
    } else {
      // If no data at all, start with one empty row
      setRows([
        {
          id: 0,
          _id: null,
          designation: "",
          hourlysalaray: "",
          overheadpercentage: "",
        },
      ]);
    }
  }, [data, employees]);

  // Search input handler
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredRows = useMemo(() => {
    if (!searchQuery.trim()) return rows;

    const query = searchQuery.toLowerCase().trim();
    return rows.filter((row) => {
      // Existing search criteria
      const basicMatch =
        row.designation.toLowerCase().includes(query) ||
        (row.hourlysalaray && row.hourlysalaray.toString().includes(query)) ||
        (row.overheadpercentage &&
          row.overheadpercentage.toString().includes(query));

      // New: Search by employee name
      if (row.personid) {
        const employee = employees.find((emp) => emp._id === row.personid);
        if (employee) {
          const employeeName =
            `${employee.EmpFirstName} ${employee.EmpLastName}`.toLowerCase();
          const employeeMatch = employeeName.includes(query);
          return basicMatch || employeeMatch;
        }
      }

      return basicMatch;
    });
  }, [rows, searchQuery, employees]);
  // Sorting functions
  const handleSort = (key) => {
    let direction = "ascending";

    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
  };

  const sortRows = React.useCallback(
    (rowsToSort) => {
      if (!sortConfig.key) {
        // When no sort is active, put empty rows (no designation) at the bottom
        return [...rowsToSort].sort((a, b) => {
          const aHasDesignation = a.designation && a.designation.trim() !== "";
          const bHasDesignation = b.designation && b.designation.trim() !== "";
          
          if (aHasDesignation && !bHasDesignation) return -1;
          if (!aHasDesignation && bHasDesignation) return 1;
          return 0;
        });
      }

      return [...rowsToSort].sort((a, b) => {
        // Put rows without designation at top when ascending, at bottom when descending
        const aHasDesignation = a.designation && a.designation.trim() !== "";
        const bHasDesignation = b.designation && b.designation.trim() !== "";
        
        if (!aHasDesignation && bHasDesignation) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aHasDesignation && !bHasDesignation) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        
        // If both have designation or both don't, proceed with normal sorting
        // Employee sorting - by employee name
        if (sortConfig.key === "employee") {
          const getEmployeeName = (row) => {
            if (!row.personid) return "";
            const employee = employees.find((emp) => emp._id === row.personid);
            return employee
              ? `${employee.EmpFirstName} ${employee.EmpLastName}`.toLowerCase()
              : "";
          };

          const aValue = getEmployeeName(a);
          const bValue = getEmployeeName(b);

          if (aValue < bValue) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        // Existing sorting logic for other columns
        if (
          sortConfig.key === "hourlysalaray" ||
          sortConfig.key === "overheadpercentage"
        ) {
          const aValue = parseFloat(a[sortConfig.key]) || 0;
          const bValue = parseFloat(b[sortConfig.key]) || 0;

          if (aValue < bValue) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        if (sortConfig.key === "designation") {
          const aValue = a[sortConfig.key] || "";
          const bValue = b[sortConfig.key] || "";

          if (aValue.toLowerCase() < bValue.toLowerCase()) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue.toLowerCase() > bValue.toLowerCase()) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        return 0;
      });
    },
    [sortConfig, employees]
  );

  // Other Expenses functions
  const handleAddOtherExpenseRow = () => {
    if (isViewOnly) return;
    const newId = Date.now(); // Use timestamp for unique IDs

    setOtherExpenseRows([
      ...otherExpenseRows,
      {
        id: newId,
        description: "",
        cost: "",
        unit: "",
      },
    ]);
  };

  const handleOtherExpenseInputChange = (e, rowId, field) => {
    const value = e.target.value;

    if (field === "cost" && value !== "" && isNaN(value)) {
      return;
    }

    setOtherExpenseRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id !== rowId) return row;
        return { ...row, [field]: value };
      })
    );
  };

  // const handleAddRow = () => {
  //   const newId =
  //     rows.length > 0 ? Math.max(...rows.map((row) => row.id)) + 1 : 0;
  //   setRows([
  //     ...rows,
  //     {
  //       id: newId,
  //       designation: "",
  //       hourlysalaray: "",
  //       overheadpercentage: "",
  //     },
  //   ]);
  // };
  const handleAddRow = () => {
    if (!canAddHourlyRates) {
      enqueueSnackbar("You do not have permission to add hourly rates.", {
        variant: "warning",
      });
      return;
    }
    const newId =
      rows.length > 0 ? Math.max(...rows.map((row) => row.id)) + 1 : 0;

    // Create a new row
    const newRow = {
      id: newId,
      designation: "",
      hourlysalaray: "",
      overheadpercentage: "",
    };

    // If last row is empty, replace it instead of adding new one
    // const lastRow = rows[rows.length - 1];
    // const isLastRowEmpty = lastRow && !lastRow.designation && !lastRow.hourlysalaray && !lastRow.overheadpercentage;

    // if (isLastRowEmpty) {
    //   // Replace the empty last row
    //   const updatedRows = [...rows];
    //   updatedRows[updatedRows.length - 1] = newRow;
    //   setRows(updatedRows);
    // } else {
    // Add new row at the end
    setRows([...rows, newRow]);
    // }
  };

  const handleInputChange = (e, rowId, field) => {
    const targetRow = rows.find((r) => r.id === rowId);
    const isExisting = !!targetRow?._id;

    if (isExisting && !canEditHourlyRates) {
      enqueueSnackbar("You do not have permission to edit hourly rates.", {
        variant: "warning",
      });
      return;
    }

    if (!isExisting && !canAddHourlyRates) {
      enqueueSnackbar("You do not have permission to add hourly rates.", {
        variant: "warning",
      });
      return;
    }
    const value = e.target.value;

    if (
      (field === "overheadpercentage" || field === "hourlysalaray") &&
      value !== "" &&
      isNaN(value)
    ) {
      return;
    }

    // Clear sort when editing to prevent rows from reordering
    if (field === "hourlysalaray" || field === "overheadpercentage") {
      if (sortConfig.key === field) {
        setSortConfig({ key: null, direction: "ascending" });
      }
    }

    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (row.id !== rowId) return row;

        const updatedRow = { ...row, [field]: value };

        if (
          field === "hourlysalaray" &&
          useDefaultOverhead &&
          value !== "" &&
          !isNaN(value)
        ) {
          const overheadValue = (
            (parseFloat(value) * parseFloat(defaultOverheadPercentage || 0)) /
            100
          ).toFixed(2);
          updatedRow.overheadpercentage = overheadValue;
        }

        if (row._id) {
          const originalRow = data.find((q) => q._id === row._id);
          if (originalRow) {
            const isModified =
              (field === "designation" && value !== originalRow.designation) ||
              (field === "hourlysalaray" &&
                parseFloat(value || 0) !== originalRow.hourlysalaray) ||
              (field === "overheadpercentage" &&
                parseFloat(value || 0) !== originalRow.overheadpercentage);

            if (isModified) {
              setModifiedRows((prev) => {
                const filtered = prev.filter((r) => r._id !== row._id);
                return [...filtered, updatedRow];
              });
            }
          }
        }

        return updatedRow;
      });

      // Check if all overhead percentages are the same after update
      if (field === "overheadpercentage" || field === "hourlysalaray") {
        const calculatedPercents = updatedRows
          .map(({ hourlysalaray, overheadpercentage }) => {
            if (!hourlysalaray || !overheadpercentage) return null;
            const hourlyValue = parseFloat(
              hourlysalaray.toString().replace(/,/g, "")
            );
            const overheadValue = parseFloat(
              overheadpercentage.toString().replace(/,/g, "")
            );
            if (!hourlyValue || isNaN(hourlyValue) || isNaN(overheadValue))
              return null;
            return Number(((overheadValue / hourlyValue) * 100).toFixed(2));
          })
          .filter((v) => v !== null);

        const uniquePercents = [...new Set(calculatedPercents)];

        if (uniquePercents.length === 1 && calculatedPercents.length > 0) {
          // All percentages are the same, keep the default
          setDefaultOverheadPercentage(uniquePercents[0]);
        } else if (calculatedPercents.length > 0) {
          // Different percentages, clear the default
          setDefaultOverheadPercentage("");
        }
      }

      return updatedRows;
    });
  };

  const handleSaveOtherExpenses = async () => {
    const normalizedRows = otherExpenseRows.map((row) => ({
      ...row,
      cost:
        row.cost !== undefined && !isNaN(row.cost)
          ? Number(row.cost)
          : row.cost,
      unit:
        row.unit !== undefined && !isNaN(row.unit)
          ? Number(row.unit)
          : row.unit,
    }));

    const payload = {
      expenses: normalizedRows,
    };

    try {
      SetisLoading(true);
      await dispatch(createOtherExpense(payload));
      // enqueueSnackbar("Other Expenses saved successfully", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to save Other Expenses", { variant: "error" });
    } finally {
      SetisLoading(false);
    }
  };

  // const handleSavehour = async () => {
  //   SetisLoading(true);
  //   try {
  //     if (modifiedRows.length > 0) {
  //       const updatePayload = modifiedRows.map((row) => ({
  //         _id: row._id,
  //         designation: row.designation.trim(),
  //         hourlysalaray: parseFloat(row.hourlysalaray),
  //         overheadpercentage: parseFloat(row.overheadpercentage),

  //       }));

  //       await dispatch(updateSalesHourlyRate({ hourlyrates: updatePayload })).unwrap();
  //     }

  //     const newRows = rows.filter((row) => !row._id);
  //     if (newRows.length > 0) {
  //       const createPayload = newRows.map((row) => ({
  //         designation: row.designation.trim(),
  //         hourlysalaray: parseFloat(row.hourlysalaray),
  //         overheadpercentage: parseFloat(row.overheadpercentage),

  //       }));

  //       await dispatch(createSalesHourlyRate({ hourlyrates: createPayload })).unwrap();
  //     }

  //     // if (modifiedRows.length > 0 || newRows.length > 0) {
  //     //   enqueueSnackbar("Hourly Rates saved successfully!", {
  //     //     variant: "success",
  //     //   });
  //     // }

  //     await dispatch(fetchSalesHourlyRates());
  //     setModifiedRows([]);
  //   } catch (error) {
  //     enqueueSnackbar(error.message || "Failed to save quotation", {
  //       variant: "error",
  //     });
  //   } finally {
  //     SetisLoading(false);
  //     setUseDefaultOverhead(false)
  //   }
  // };

  const handleSavehour = async () => {
    SetisLoading(true);
    try {
      // Filter out completely empty rows (no designation, no salary, no overhead)
      const rowsToSave = rows.filter(
        (row) =>
          row.designation.trim() !== "" ||
          row.hourlysalaray !== "" ||
          row.overheadpercentage !== ""
      );

      if (modifiedRows.length > 0) {
        const updatePayload = modifiedRows
          .filter((row) => row.designation.trim() !== "") // Only save rows with designation
          .map((row) => ({
            _id: row._id,
            designation: row.designation.trim(),
            hourlysalaray: parseFloat(row.hourlysalaray) || 0,
            overheadpercentage: parseFloat(row.overheadpercentage) || 0,
          }));

        if (updatePayload.length > 0) {
          await dispatch(
            updateSalesHourlyRate({ hourlyrates: updatePayload })
          ).unwrap();
        }
      }

      const newRows = rowsToSave.filter(
        (row) => !row._id && row.designation.trim() !== ""
      );
      if (newRows.length > 0) {
        const createPayload = newRows.map((row) => ({
          designation: row.designation.trim(),
          hourlysalaray: parseFloat(row.hourlysalaray) || 0,
          overheadpercentage: parseFloat(row.overheadpercentage) || 0,
        }));

        await dispatch(
          createSalesHourlyRate({ hourlyrates: createPayload })
        ).unwrap();
      }

      await dispatch(fetchSalesHourlyRates());
      window.dispatchEvent(new Event("sales-hourly-rates-updated"));
      setModifiedRows([]);
    } catch (error) {
      enqueueSnackbar(error.message || "Failed to save quotation", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  const handleSaveExpense = async () => {
    try {
      await handleSavehour();
      await handleSaveOtherExpenses();
      enqueueSnackbar("Rates and Expenses saved successfully!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error.message || "Failed to save quotation", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(fetchOtherExpenses());
    }
  };

  const handleDeleteRow = (id, index) => {
    if (!canDeleteHourlyRates) {
      enqueueSnackbar("You do not have permission to delete hourly rates.", {
        variant: "warning",
      });
      return;
    }
    setindex(index);
    if (id) {
      setRowToDelete(id);
      setIsModalOpen(true);
    } else {
      setIsModal(true);
    }
  };

  const handleexpenseDeleteRow = (id) => {
    setexpenseID(id);
    setisexpenseModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!canDeleteHourlyRates) {
      enqueueSnackbar("You do not have permission to delete hourly rates.", {
        variant: "warning",
      });
      setIsModalOpen(false);
      return;
    }
    SetisLoading(true);
    try {
      await dispatch(deleteSalesHourlyRate(_id));
      enqueueSnackbar("Row  Deleted Successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      // setOpenDropdownId(null);
      setRowToDelete(null);
      setIsModalOpen(false);
      dispatch(fetchSalesHourlyRates());
      window.dispatchEvent(new Event("sales-hourly-rates-updated"));
      dispatch(fetchOtherExpenses());
    }
  };

  const confirmExpenseDelete = async () => {
    SetisLoading(true);
    try {
      await dispatch(deleteOtherExpense(expenseID));
      enqueueSnackbar("Row  Deleted Successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      // setOpenDropdownId(null);
      setexpenseID(null);
      setisexpenseModalOpen(false);
      dispatch(fetchOtherExpenses());
    }
  };

  const toggleDropdownemployee = (rowId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent event bubbling
    }
    setopenDropdownemployeeId(openDropdownemployeeId === rowId ? null : rowId);
  };

  const handleExpenseSearchInputChange = (e) => {
    setExpenseSearchQuery(e.target.value);
  };

  const handleExpenseSort = (key) => {
    let direction = "ascending";

    if (
      expenseSortConfig.key === key &&
      expenseSortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }

    setExpenseSortConfig({ key, direction });
  };

  const sortExpenseRows = React.useCallback(
    (rowsToSort) => {
      if (!expenseSortConfig.key) return rowsToSort;

      return [...rowsToSort].sort((a, b) => {
        if (
          expenseSortConfig.key === "cost" ||
          expenseSortConfig.key === "unit"
        ) {
          const aValue = parseFloat(a[expenseSortConfig.key]) || 0;
          const bValue = parseFloat(b[expenseSortConfig.key]) || 0;

          if (aValue < bValue) {
            return expenseSortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue > bValue) {
            return expenseSortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        if (expenseSortConfig.key === "description") {
          const aValue = a[expenseSortConfig.key] || "";
          const bValue = b[expenseSortConfig.key] || "";

          if (aValue.toLowerCase() < bValue.toLowerCase()) {
            return expenseSortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue.toLowerCase() > bValue.toLowerCase()) {
            return expenseSortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        return 0;
      });
    },
    [expenseSortConfig]
  );

  // Add this useMemo to filter and sort expense rows
  const filteredExpenseRows = useMemo(() => {
    let filtered = otherExpenseRows;

    if (expenseSearchQuery.trim()) {
      const query = expenseSearchQuery.toLowerCase().trim();
      filtered = otherExpenseRows.filter(
        (row) =>
          row.description.toLowerCase().includes(query) ||
          (row.cost && row.cost.toString().includes(query)) ||
          (row.unit && row.unit.toString().includes(query))
      );
    }

    return sortExpenseRows(filtered);
  }, [otherExpenseRows, expenseSearchQuery, sortExpenseRows]);

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdownemployeeId !== null) {
        const openDropdownRef =
          dropdownRefs.current[`dropdown-${openDropdownemployeeId}`];

        if (openDropdownRef && !openDropdownRef.contains(event.target)) {
          setopenDropdownemployeeId(null);
        }
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [openDropdownemployeeId]);

  const applyDefaultOverheadToRows = (percentage) => {

    console.log("gfsdgs percentage", percentage)
    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (!row.hourlysalaray || isNaN(row.hourlysalaray)) return row;

        const hourlysalarayValue =
          typeof row.hourlysalaray === "string"
            ? parseFloat(row.hourlysalaray.replace(/,/g, ""))
            : parseFloat(row.hourlysalaray);

        const head = percentage || 10;
        console.log("gfsdgs head", head)

        const overhead = (
          (hourlysalarayValue * parseFloat(head)) /
          100
        ).toFixed(2);

        const updatedRow = {
          ...row,
          overheadpercentage: overhead,
        };

        // If this row has an _id (existing row), mark it as modified
        if (row._id) {
          const originalRow = data.find((q) => q._id === row._id);
          if (originalRow) {
            const isModified =
              parseFloat(overhead) !== originalRow.overheadpercentage;

            if (isModified) {
              setModifiedRows((prevModified) => {
                const filtered = prevModified.filter((r) => r._id !== row._id);
                return [...filtered, updatedRow];
              });
            }
          }
        }

        return updatedRow;
      });

      return updatedRows;
    });
  };

  const sortedRows = useMemo(() => {
    const filtered = filteredRows; // This already filters based on search
    return sortRows(filtered);
  }, [filteredRows, sortRows]);
  // useEffect(() => {
  //   // If defaultOverheadPercentage is empty or null, uncheck the checkbox
  //   if (!defaultOverheadPercentage) {
  //     setUseDefaultOverhead(false);
  //   }
  // }, [defaultOverheadPercentage]);
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <>
        <div className="pt-6">
          <div className="mr-4 p-4 min-h-[20rem] bg-white rounded-md border border-gray-200 shadow-lg">
            <div className="flex justify-between py-1 align-middle items-center pr-8">
              <h1 className="text-xl mb-2 font-semibold">Add Hourly Rates</h1>

              <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                <MdSearch className=" w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className="bg-[#e0e7ff] outline-none w-[80%]"
                />
              </div>
            </div>
            <div className="px-[2rem] w-full text-xs">
              <div className="relative  parent w-full">
                {/* Fixed Header */}
                <div
                  style={{ zIndex: 1000 }}
                  className="w-full sticky top-0 left-0  bg-[#e8e8e8]"
                >
                  <div className="flex w-full">
                    <div className="w-[33.33%] relative flex justify-between align-middle items-center bg-[#e8e8e8] font-semibold p-2 ">
                      Designation
                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("designation")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("designation")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[33.33%] relative flex justify-center align-middle items-center bg-[#e8e8e8] font-semibold p-2 ">
                      Hourly Salary ({currency})
                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("hourlysalaray")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("hourlysalaray")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="w-[33.33%] relative  bg-[#e8e8e8]  font-semibold p-2 e flex gap-1 justify-between align-middle items-center">
                      <div className="flex gap-1 align-middle items-center">
                        Overhead ({currency}) (
                        <input
                          type="number"
                          value={defaultOverheadPercentage}
                          // onChange={(e) => {
                          //   const value = e.target.value;
                          //   if (
                          //     value === "" ||
                          //     (!isNaN(value) && parseFloat(value) >= 0)
                          //   ) {
                          //     setDefaultOverheadPercentage(value);
                          //   }
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setUseDefaultOverhead(false);

                            // Allow empty input
                            if (value === "") {
                              setDefaultOverheadPercentage(value);
                              return;
                            }

                            // Parse the value as a number
                            const numValue = parseFloat(value);

                            // Only update if it's a valid number between 0 and 100
                            if (
                              !isNaN(numValue) &&
                              numValue >= 0 &&
                              numValue <= 100
                            ) {
                              setDefaultOverheadPercentage(value);
                            }
                          }}
                          placeholder="10"
                          className="Overheadnumber h-full bg-transparent outline-none w-4"
                        />
                        %
                        <div className="relative inline-flex items-center justify-center mt-1">
                          <input
                            type="checkbox"
                            checked={useDefaultOverhead}
                            onChange={async (e) => {
                              const isChecked = e.target.checked;
                              setUseDefaultOverhead(isChecked);

                              if (isChecked) {
                               

                                applyDefaultOverheadToRows(
                                  defaultOverheadPercentage
                                );

                                setOverheadPercentage(
                                  defaultOverheadPercentage
                                );

                                enqueueSnackbar(
                                  "Default overhead percentage applied",
                                  { variant: "success" }
                                );
                              } else {
                                setDefaultOverheadPercentage("");
                                setOverheadPercentage(null);
                              }
                            }}
                            className={`Overheadcheckmark h-4 w-4 rounded border border-gray-300 appearance-none
             transition-colors duration-200 focus:ring-2 focus:ring-blue-500 
            ${useDefaultOverhead ? "bg-yellow-400 border-black" : "bg-white"}`}
                            disabled={isLoading}
                          />
                          {useDefaultOverhead && (
                            <svg
                              className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-3 w-3 text-white pointer-events-none"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          )}
                        </div>
                        )
                      </div>

                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="w-[33.33%] relative font-semibold p-2 flex gap-2 justify-center items-center bg-[#e8e8e8]">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="whitespace-nowrap">
                          Overhead ({currency})
                        </span>
                        <div className="flex gap-0.5 align-middle items-center">
                          (
                          <div className="flex items-center gap-1 rounded-md ">
                            <input
                              type="number"
                              value={defaultOverheadPercentage}
                              onChange={(e) => {
                                const value = e.target.value;
                                setUseDefaultOverhead(false);

                                // Allow empty input
                                if (value === "") {
                                  setDefaultOverheadPercentage(value);
                                  return;
                                }

                                // Parse the value as a number
                                const numValue = parseFloat(value);

                                // Only update if it's a valid number between 0 and 100
                                if (
                                  !isNaN(numValue) &&
                                  numValue >= 0 &&
                                  numValue <= 100
                                ) {
                                  setDefaultOverheadPercentage(value);
                                }
                              }}
                              placeholder="10"
                              className="w-6 text-center border bg-white outline-none focus:ring-1 focus:ring-blue-400 rounded px-1 py-0.5"
                              min="0"
                              max="100"
                            />
                            <span className="text-gray-600 text-sm">%</span>
                            <div className="relative inline-flex items-center justify-center ml-1">
                              <input
                                type="checkbox"
                                checked={useDefaultOverhead}
                                onChange={async (e) => {
                                  const isChecked = e.target.checked;
                                  setUseDefaultOverhead(isChecked);

                                  if (isChecked) {
                                    applyDefaultOverheadToRows(
                                      defaultOverheadPercentage
                                    );

                                    setOverheadPercentage(
                                      defaultOverheadPercentage
                                    );

                                    enqueueSnackbar(
                                      "Default overhead percentage applied",
                                      { variant: "success" }
                                    );
                                  } else {
                                    // Clear the applied overhead when unchecked
                                    setDefaultOverheadPercentage("");
                                    setOverheadPercentage(null);
                                  }
                                }}
                                className={`h-4 w-4 rounded border-2 appearance-none
                                transition-colors duration-200 focus:ring-2 focus:ring-blue-500 cursor-pointer
                                ${
                                  useDefaultOverhead
                                    ? "bg-yellow-400 border-yellow-500"
                                    : "bg-white border-gray-300"
                                }`}
                                disabled={isLoading}
                              />
                              {useDefaultOverhead && (
                                <svg
                                  className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-3 w-3 text-gray-800 pointer-events-none"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M5 13l4 4L19 7"
                                  />
                                </svg>
                              )}
                            </div>
                          </div>
                          )
                        </div>
                      </div>

                      <div className="flex absolute right-2 flex-col">
                        <div
                          className="cursor-pointer hover:bg-gray-200 rounded transition-colors"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2 hover:bg-gray-200 rounded transition-colors"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="w-[4%] flex gap-1 justify-center align-middle items-center bg-[#e8e8e8] p-1 group-hover:bg-[#b8c4f0]">
                      <div className="py-1 flex justify-center align-middle items-center text-md">
                        <DeleteIcon className="deleteicon cursor-pointer " />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content with padding to account for fixed header */}
                <div className="w-full">
                  <div className="Grouplist w-full">
                    <div className="hourlyrate">
                      {sortedRows?.length > 0 ? (
                        sortedRows.map((row, index) => (
                          <div
                            key={index}
                            className="mainrow relative group flex w-full transition-colors duration-200"
                          >
                            <div className="w-[33.33%] p-1 border-b border-l flex justify-start align-middle items-center">
                              {row.designation ? (
                                <span className="capitalize text-black flex justify-start align-middle items-center ">
                                  {formatDesignationLabel(row.designation)}
                                </span>
                              ) : (
                                <div className="relative servicedropdown flex items-center w-full">
                                  <ExpandMoreIcon
                                    onClick={(e) =>
                                      toggleDropdownemployee(row.id, e)
                                    }
                                    className="absolute right-2 cursor-pointer text-black"
                                  />

                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      toggleDropdownemployee(row.id, e)
                                    }
                                    className="border w-full border-gray-400 rounded-md p-2 shadow-md text-start text-black"
                                  >
                                    Select Designation
                                  </button>

                                  {openDropdownemployeeId === row.id && (
                                    <div
                                      ref={(el) =>
                                        (dropdownRefs.current[
                                          `dropdown-${row.id}`
                                        ] = el)
                                      }
                                      onClick={(e) => e.stopPropagation()} // ✅ ADD THIS
                                      style={{ zIndex: 999 }}
                                      className="Designationdropdown absolute top-full left-0 w-full bg-white border shadow-lg"
                                    >
                                      {/* 🔍 Search */}
                                      <div className="p-2">
                                        <input
                                          type="text"
                                          placeholder="Search employee"
                                          className="w-full border rounded-md px-2 py-1"
                                          value={searchTerm || ""}
                                          onChange={(e) =>
                                            setSearchTerm(
                                              e.target.value.toLowerCase()
                                            )
                                          }
                                        />
                                      </div>

                                      <div className="max-h-80 overflow-y-auto capitalize">
                                        {(() => {
                                          const usedDesignations = new Set(
                                            rows
                                              .filter((r) => r.designation)
                                              .map((r) => r.designation)
                                          );

                                          const uniqueDesignations = new Map();

                                          employees
                                            .filter((emp) => emp.servicetype)
                                            .filter((emp) => {
                                              if (!searchTerm) return true;

                                              const searchable = [
                                                emp.EmpFirstName,
                                                emp.EmpLastName,
                                                emp.servicetype,
                                                ...(emp.customRoles || []),
                                              ]
                                                .join(" ")
                                                .toLowerCase();

                                              return searchable.includes(
                                                searchTerm
                                              );
                                            })
                                            .forEach((emp) => {
                                              const parts = [];

                                              if (emp.servicetype)
                                                parts.push(emp.servicetype);

                                              if (emp.customRoles?.length) {
                                                parts.push(
                                                  [...emp.customRoles]
                                                    .sort()
                                                    .join(", ")
                                                );
                                              }

                                              const designation =
                                                parts.join(" ");

                                              if (
                                                designation &&
                                                !uniqueDesignations.has(
                                                  designation
                                                )
                                              ) {
                                                uniqueDesignations.set(
                                                  designation,
                                                  designation
                                                );
                                              }
                                            });

                                          return Array.from(
                                            uniqueDesignations.values()
                                          )
                                            .filter(
                                              (d) => !usedDesignations.has(d)
                                            )
                                            .map((designation, index) => (
                                              <div
                                                key={index}
                                                className="p-2 hover:bg-gray-200 border-b cursor-pointer"
                                                onClick={() => {
                                                  if (
                                                    designation.includes(
                                                      "Hardware"
                                                    )
                                                  ) {
                                                    enqueueSnackbar(
                                                      "Hourly Salary included in Hardware Parts",
                                                      { variant: "success" }
                                                    );
                                                  }
                                                  setRows((prev) =>
                                                    prev.map((r) =>
                                                      r.id === row.id
                                                        ? { ...r, designation }
                                                        : r
                                                    )
                                                  );
                                                  setopenDropdownemployeeId(
                                                    null
                                                  );
                                                  setSearchTerm("");
                                                }}
                                              >
                                                {formatDesignationLabel(designation)}
                                              </div>
                                            ));
                                        })()}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            <div className="w-[33.33%] flex gap-1 justify-center align-middle items-center p-1 border-b">
                              <input
                                type="text"
                                disabled={
                                  row.designation.includes("Hardware") ||
                                  (row._id ? !canEditHourlyRates : !canAddHourlyRates)
                                }
                                value={
                                  row.designation.includes("Hardware")
                                    ? "Considered in Parts"
                                    : USAComma(row.hourlysalaray)
                                }
                                onChange={(e) => {
                                  let value = e.target.value
                                    .split(".")[0]
                                    .replace(/,/g, "")
                                    .replace(/\D/g, "");

                                  handleInputChange(
                                    {
                                      ...e,
                                      target: { ...e.target, value },
                                    },
                                    row.id,
                                    "hourlysalaray"
                                  );
                                }}
                                placeholder="Enter Hourly Salary"
                                className={`w-1/2 p-2 outline-none text-black rounded text-center ${
                                  row.designation.includes("Hardware")
                                    ? "bg-transparent"
                                    : "bg-[#e8e8e8]"
                                }`}
                              />
                            </div>
                            <div className="w-[33.33%] flex gap-1 justify-center align-middle items-center pr-2 p-1 border-b">
                              <input
                                disabled={
                                  row.designation.includes("Hardware") ||
                                  (row._id ? !canEditHourlyRates : !canAddHourlyRates)
                                }
                                type="text" // ✅ Use text to block "e", "+", "-" etc.
                                value={
                                  row.designation.includes("Hardware")
                                    ? "Considered in Parts"
                                    : formatOverheadDisplay(row.overheadpercentage)
                                }
                                onChange={(e) => {
                                  let value = e.target.value
                                    .replace(/,/g, "")
                                    .replace(/[^\d.]/g, "");
                                  const dotParts = value.split(".");
                                  if (dotParts.length > 2) {
                                    value = `${dotParts[0]}.${dotParts.slice(1).join("")}`;
                                  }
                                  if (dotParts[1]?.length > 2) {
                                    value = `${dotParts[0]}.${dotParts[1].slice(0, 2)}`;
                                  }

                                  handleInputChange(
                                    {
                                      ...e,
                                      target: { ...e.target, value },
                                    },
                                    row.id,
                                    "overheadpercentage"
                                  );
                                }}
                                placeholder="Enter Overhead"
                                className={`w-1/2 p-2 outline-none text-black rounded text-center ${
                                  row.designation.includes("Hardware")
                                    ? "bg-transparent"
                                    : "bg-[#e8e8e8]"
                                }`}
                              />
                            </div>

                            <div className="w-[4%] flex gap-1 justify-center align-middle items-center pr-2 p-1 border-b border-r">
                              <div className="deleteicondiv py-1 flex justify-center align-middle items-center text-md opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                {canDeleteHourlyRates && (
                                  <DeleteIcon
                                    className="deleteicon cursor-pointer text-[#df3b3b] hover:text-[#c12a2a]"
                                    onClick={() =>
                                      handleDeleteRow(row._id, index)
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="w-full text-center text-red-600 py-4">
                          No Data Present
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex px-[2rem] justify-start items-center w-full  mt-2 mb-4">
              <div
                className={`rounded-md p-1 shadow-lg border flex justify-center items-center ${
                  canAddHourlyRates ? "bg-white cursor-pointer" : "bg-gray-100 cursor-not-allowed"
                }`}
              >
                <AddIcon
                  onClick={handleAddRow}
                  className={canAddHourlyRates ? "text-black" : "text-gray-400"}
                />
              </div>
            </div>

            <div className="OtherExpensesBlock pt-10">
              <div className="flex justify-between align-middle items-center py-2 pr-8">
                <h3 className=" font-semibold">
                  <h1 className="text-xl mb-2 font-semibold">Other Expenses</h1>
                </h3>
                <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className=" w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    value={expenseSearchQuery}
                    onChange={handleExpenseSearchInputChange}
                    placeholder="Search"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                  />
                </div>
              </div>

              <div className="Otherbox w-full px-[2rem] text-xs">
                <div className="flex w-full">
                  <div className="w-[50%] bg-[#e8e8e8] relative flex justify-between align-middle items-center  font-semibold p-2  ">
                    Description
                    <div className="flex absolute right-2 top-0 flex-col">
                      <div
                        className="cursor-pointer"
                        onClick={() => handleExpenseSort("description")}
                      >
                        <ArrowDropUp
                          sx={{
                            fontSize: "22px",
                          }}
                        />
                      </div>
                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => handleExpenseSort("description")}
                      >
                        <ArrowDropDown
                          sx={{
                            fontSize: "22px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[50%] bg-[#e8e8e8] relative flex justify-center align-middle items-center  font-semibold p-2  ">
                    Cost ({currency} / day)
                    <div className="flex absolute right-2 top-0 flex-col">
                      <div
                        className="cursor-pointer"
                        onClick={() => handleExpenseSort("cost")}
                      >
                        <ArrowDropUp
                          sx={{
                            fontSize: "22px",
                          }}
                        />
                      </div>
                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => handleExpenseSort("cost")}
                      >
                        <ArrowDropDown
                          sx={{
                            fontSize: "22px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[4%] flex gap-1 justify-center align-middle items-center bg-[#e8e8e8] p-1 group-hover:bg-[#b8c4f0]">
                    <div className="py-1 flex justify-center align-middle items-center text-md">
                      <DeleteIcon className="deleteicon cursor-pointer " />
                    </div>
                  </div>
                </div>

                {filteredExpenseRows?.map((row) => (
                  <div key={row.id} className="flex expense w-full group">
                    <div className="w-[50%] p-2 flex align-middle items-center border-b  border-l">
                      <input
                        type="text"
                        value={row.description}
                        onChange={(e) =>
                          handleOtherExpenseInputChange(
                            e,
                            row.id,
                            "description"
                          )
                        }
                        placeholder="Enter description"
                        className="w-full p-2 outline-none bg-transparent text-black"
                      />
                    </div>
                    <div className="w-[50%] p-2 flex justify-center align-middle items-center border-b">
                      <input
                        type="text"
                        value={USAComma(row.cost)}
                        // onChange={(e) => handleOtherExpenseInputChange(e, row.id, "cost")}
                        onChange={(e) => {
                          let value = e.target.value
                            .split(".")[0]
                            .replace(/,/g, "")
                            .replace(/\D/g, "");

                          // ✅ Allow only digits with optional decimal and max 3 decimals

                          handleOtherExpenseInputChange(
                            {
                              ...e,
                              target: { ...e.target, value },
                            },
                            row.id,
                            "cost"
                          );
                        }}
                        placeholder="Enter cost"
                        className="w-1/2 p-2 outline-none bg-[#e8e8e8] text-black rounded text-center"
                      />
                    </div>

                    <div className="w-[4%] flex gap-1 justify-center align-middle items-center pr-2 p-1 border-b  border-r">
                      <div className="deleteicondiv py-1 flex justify-center align-middle items-center text-md opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                        <DeleteIcon
                          className="deleteicon cursor-pointer text-[#df3b3b] hover:text-[#c12a2a]"
                          onClick={() => handleexpenseDeleteRow(row._id)}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <div className="Otherboxbutoons flex justify-center items-center w-full relative mt-2 mb-4">
                  <div
                    className={`absolute left-0 top-0 rounded-md p-1 shadow-lg border flex justify-center items-center ${isViewOnly ? "bg-[#d1d5db] cursor-not-allowed pointer-events-none opacity-60" : "bg-white cursor-pointer"}`}
                    onClick={handleAddOtherExpenseRow}
                  >
                    <AddIcon className={isViewOnly ? "text-[#9ca3af]" : "text-black"} />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end pt-8 pr-[2rem]">
              <button
                onClick={handleSaveExpense}
                className={`px-4 py-2 font-semibold rounded-md ${
                  (!canAddHourlyRates && !canEditHourlyRates && !canDeleteHourlyRates) || isLoading
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-[#1973eb] text-white"
                }`}
                disabled={
                  (!canAddHourlyRates && !canEditHourlyRates && !canDeleteHourlyRates) || isLoading
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Hourly Rates?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isexpenseModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Other Expenses?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setisexpenseModalOpen(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmExpenseDelete}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isModal && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Hourly Rates?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModal(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setRows((prevRows) =>
                      prevRows.filter((_, i) => i !== index)
                    );
                    setIsModal(false);
                    enqueueSnackbar("Row Deleted Successfully", {
                      variant: "success",
                    });
                  }}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default HourlyRates;